"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubarrayArbitrary = void 0;

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var LazyIterableIterator_1 = require("../../stream/LazyIterableIterator");

var Stream_1 = require("../../stream/Stream");

var IsSubarrayOf_1 = require("./helpers/IsSubarrayOf");

var IntegerArbitrary_1 = require("./IntegerArbitrary");

var SubarrayArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(SubarrayArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(SubarrayArbitrary);

  function SubarrayArbitrary(originalArray, isOrdered, minLength, maxLength) {
    var _this;

    _classCallCheck(this, SubarrayArbitrary);

    _this = _super.call(this);
    _this.originalArray = originalArray;
    _this.isOrdered = isOrdered;
    _this.minLength = minLength;
    _this.maxLength = maxLength;
    if (minLength < 0 || minLength > originalArray.length) throw new Error('fc.*{s|S}ubarrayOf expects the minimal length to be between 0 and the size of the original array');
    if (maxLength < 0 || maxLength > originalArray.length) throw new Error('fc.*{s|S}ubarrayOf expects the maximal length to be between 0 and the size of the original array');
    if (minLength > maxLength) throw new Error('fc.*{s|S}ubarrayOf expects the minimal length to be inferior or equal to the maximal length');
    _this.lengthArb = new IntegerArbitrary_1.IntegerArbitrary(minLength, maxLength);
    _this.biasedLengthArb = minLength !== maxLength ? new IntegerArbitrary_1.IntegerArbitrary(minLength, minLength + Math.floor(Math.log(maxLength - minLength) / Math.log(2))) : _this.lengthArb;
    return _this;
  }

  _createClass(SubarrayArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var _this2 = this;

      var lengthArb = biasFactor !== undefined && mrng.nextInt(1, biasFactor) === 1 ? this.biasedLengthArb : this.lengthArb;
      var size = lengthArb.generate(mrng, undefined);
      var sizeValue = size.value;
      var remainingElements = this.originalArray.map(function (_v, idx) {
        return idx;
      });
      var ids = [];

      for (var index = 0; index !== sizeValue; ++index) {
        var selectedIdIndex = mrng.nextInt(0, remainingElements.length - 1);
        ids.push(remainingElements[selectedIdIndex]);
        remainingElements.splice(selectedIdIndex, 1);
      }

      if (this.isOrdered) {
        ids.sort(function (a, b) {
          return a - b;
        });
      }

      return new NextValue_1.NextValue(ids.map(function (i) {
        return _this2.originalArray[i];
      }), size.context);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      if (!Array.isArray(value)) {
        return false;
      }

      if (!this.lengthArb.canShrinkWithoutContext(value.length)) {
        return false;
      }

      return (0, IsSubarrayOf_1.isSubarrayOf)(this.originalArray, value);
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this3 = this;

      if (value.length === 0) {
        return Stream_1.Stream.nil();
      }

      return this.lengthArb.shrink(value.length, context).map(function (newSize) {
        return new NextValue_1.NextValue(value.slice(value.length - newSize.value), newSize.context);
      }).join(value.length > this.minLength ? (0, LazyIterableIterator_1.makeLazy)(function () {
        return _this3.shrink(value.slice(1), undefined).filter(function (newValue) {
          return _this3.minLength <= newValue.value.length + 1;
        }).map(function (newValue) {
          return new NextValue_1.NextValue([value[0]].concat(newValue.value), undefined);
        });
      }) : Stream_1.Stream.nil());
    }
  }]);

  return SubarrayArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.SubarrayArbitrary = SubarrayArbitrary;